import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cn7om55jvr: FaireBrandEntity = {
  token: "b_cn7om55jvr",
  type: "brand",
  name: "Eye Candy Los Angeles",
  avatarUrl:
    "https://cdn.faire.com/fastly/44dbcb42e8993c85ba6d9e9e3a0dac150c43acd791a2932598395ad86bf2cb53.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/08a256e76c591529711c06b7f97d63e4ffcc18f80e3d252e10a812c102c7e634.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/44dbcb42e8993c85ba6d9e9e3a0dac150c43acd791a2932598395ad86bf2cb53.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/08a256e76c591529711c06b7f97d63e4ffcc18f80e3d252e10a812c102c7e634.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 166,
  rating: 4.8,
  reviewCount: 117,
  isInsider: true,
  description:
    "We believe that you should have the freedom to express yourself with no limits. We encourage you to play with trends and try new things. We are here to complete your look, for every occasion, every mood, every day. \n\nWhether you’re a minimalist or maximalist, our diverse assortment of jewelry has something for everyone. We introduce new styles every month to keep up with your style needs. We aim to offer quality pieces that will stay with you forever.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:21.600Z",
    importedBy: "entity-db-cli",
  },
};
